export enum PaymentMethodType {
    Visa = 'Visa',
    Mastercard = 'Mastercard',
    AMEX = 'American Express',
    Discover = 'Discover',
    Diners = 'Diners Club',
    JCB = 'JCB',
    UnionPay = 'UnionPay',
    MIR = 'MIR',
    Generic = 'Generic'
}